import React, { useRef, useState } from 'react';
import Label from '~/src/atoms/Label';
import useSelectedPack from './useSelectedPack';
import tw from 'twin.macro';
import { LottiePlayer } from '~/src/molecules/LottiePlayer';
import Image from '~/src/atoms/Image';
import { InView } from 'react-intersection-observer';

const gradientAlignment = {
  LEFT_RIGHT: 'to right',
};

const OfferCommunication = ({ ...rest }) => {
  const { pricing = {} } = useSelectedPack();
  const lottieRef = useRef(null);
  const [, setvisible] = useState(false);

  if (!pricing?.offer?.offer_available || pricing?.offer?.offer_available === 'false') {
    return (
      <div className="w-full py-3 border border-transparent">
        <div className="py-0.5"></div>
      </div>
    );
  }

  const onViewChange = (inView) => {
    setvisible(inView);
  };

  const transformGradientColor = (backgroundData) => {
    const color = backgroundData?.gradient?.map((data, index) => {
      if (data) {
        return `rgba(${data?.r}, ${data?.g}, ${data?.b}, ${data?.a}) ${index * 50}%`;
      }
    });
    if (color[0]) {
      return `linear-gradient(${gradientAlignment[backgroundData?.direction] || 'to right'}, ${color.toString()})`;
    } else {
      return 'linear-gradient("to right", #FFFFFE 0%, #EDF8EC 51.04%, #C8F0E3 100%)';
    }
  };

  const transformBorderColor = (border) => {
    const gradient = border?.gradient[0];
    if (gradient) {
      return `rgba(${gradient?.r}, ${gradient?.g}, ${gradient?.b}, ${gradient?.a})`;
    } else {
      return '#5E9400';
    }
  };

  return (
    <InView as="div" onChange={onViewChange}>
      <div
        css={tw`flex items-center relative w-full py-0.7 pl-2 pr-1.5 cursor-pointer border border-solid rounded-2xs`}
        {...rest}
        style={{ background: transformGradientColor(pricing?.offer?.background), borderColor: transformBorderColor(pricing?.offer?.background_border) }}>
        {pricing?.offer?.offer_logo_web && (
          <div css={tw`absolute ml-2 bottom-0  h-8 w-8 cursor-pointer`} style={{ bottom: '-2px' }} ref={lottieRef}>
            {pricing?.offer?.offer_logo_web?.includes('json') ? (
              <LottiePlayer url={pricing?.offer?.offer_logo_web} lottieRef={lottieRef} />
            ) : (
              <Image src={pricing?.offer?.offer_logo_web} layout={'fill'} />
            )}
          </div>
        )}
        <Label className={'lg:text-sm xl:text-md font-semibold pr-5 py-0.5 ml-12'} style={{ color: pricing?.offer?.text_color || '#5E9400' }}>
          {pricing?.offer?.offer_entry_text}
        </Label>
        <div className="absolute caret-position">
          <ChevronDown color={pricing?.offer?.text_color} />
        </div>
        <style jsx>{`
          .caret-position {
            right: 6px;
          }
        `}</style>
      </div>
    </InView>
  );
};

export default OfferCommunication;

function ChevronDown({ color = '#5E9400' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#101010"
        fillRule="evenodd"
        d="M12 15.5a.997.997 0 01-.707-.293l-4-4a.999.999 0 111.414-1.414l3.305 3.305 3.293-3.18a1 1 0 011.39 1.439l-4 3.862A.997.997 0 0112 15.5z"
        clipRule="evenodd"></path>
      <mask id="mask0_347_1708" style={{ maskType: 'luminance' }} width="11" height="7" x="6" y="9" maskUnits="userSpaceOnUse">
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M12 15.5a.997.997 0 01-.707-.293l-4-4a.999.999 0 111.414-1.414l3.305 3.305 3.293-3.18a1 1 0 011.39 1.439l-4 3.862A.997.997 0 0112 15.5z"
          clipRule="evenodd"></path>
      </mask>
      <g mask="url(#mask0_347_1708)">
        <path fill={color} d="M0 0H24V24H0z"></path>
      </g>
    </svg>
  );
}
